var _excluded = ["icon", "children", "css"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { forwardRef, styled } from '@grupoboticario/flora-react-system';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import { AccessibleIcon } from '@radix-ui/react-accessible-icon';
var StyledList = styled(TabsPrimitive.List, {
  flexShrink: 0,
  display: 'flex',
  overflowX: 'auto',
  color: '$nonInteractivePredominant',
  boxShadow: 'inset 0 -1px 0 0 currentColor, 0 0 0 0 currentColor',
  '&[data-orientation="vertical"]': {
    boxShadow: 'none',
    flexDirection: 'column',
    overflowY: 'auto'
  }
});
var StyledTab = styled(TabsPrimitive.Trigger, {
  display: 'flex',
  flexShrink: 0,
  alignItems: 'center',
  padding: '$3',
  color: '$nonInteractivePredominant',
  userSelect: 'none',
  fontFamily: '$body',
  fontSize: '$bodySmall',
  lineHeight: '24px',
  cursor: 'pointer',
  transition: 'box-shadow 0.3s ease-out, color 0.3s ease-out',
  backgroundColor: 'transparent',
  border: 'none',
  justifyContent: 'center',
  '&:hover:not([data-disabled])': {
    color: '$linkHover',
    boxShadow: 'inset 0 -$sizes$1 0 0 currentColor, 0 0 0 0 currentColor'
  },
  '&[data-state="active"]': {
    color: '$linkDefault',
    // NOSONAR: Justification for suppressing this issue
    boxShadow: 'inset 0 -$sizes$1 0 0 currentColor, 0 0 0 0 currentColor',
    '&:not(:hover)': {
      color: '$linkDefault',
      // NOSONAR: Justification for suppressing this issue
      fill: '$linkDefault' // NOSONAR: Justification for suppressing this issue

    }
  },
  '&[data-disabled]': {
    color: '$disabledContent',
    cursor: 'not-allowed'
  },
  '&[data-orientation="vertical"]': {
    justifyContent: 'flex-start',
    padding: '$2 $3 $2 $2',
    boxShadow: 'inset -1px 0 0 currentColor, 0 0 0 currentColor',
    '&[data-state="active"], &:hover:not([data-disabled])': {
      boxShadow: 'inset -$sizes$1 0 0 currentColor, 0 0 0 currentColor'
    }
  }
});
var StyledPanel = styled(TabsPrimitive.Content, {
  flexGrow: 1,
  padding: '$4',
  color: '$nonInteractivePredominant'
});
var StyledTabs = styled(TabsPrimitive.Root, {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  '&[data-orientation="vertical"]': {
    flexDirection: 'row'
  },
  variants: {
    variant: {
      alt: {
        $$color: '$colors$nonInteractiveAltPredominant',
        ["& " + StyledTab]: {
          color: '$$color',
          '&[data-state="active"]': {
            color: '$linkAlt'
          },
          '&[data-disabled]': {
            color: '$disabledAltContent'
          },
          '&:hover:not([data-disabled])': {
            color: '$linkAltHover'
          }
        },
        ["& " + StyledPanel]: {
          color: '$nonInteractiveAltPredominant'
        }
      }
    }
  }
});

/**
 * @tutorial https://flora.gb.tech/docs/components/core/tabs
 */
export var Tab = forwardRef((_ref, forwardedRef) => {
  var {
    icon,
    children,
    css
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var label = React.Children.toArray(children).find(child => typeof child === 'string') || '';
  return /*#__PURE__*/React.createElement(StyledTab, _extends({}, rest, {
    css: _extends({}, css, {
      svg: {
        marginRight: '$2'
      }
    }),
    "data-flora": "tab-button",
    ref: forwardedRef
  }), icon && /*#__PURE__*/React.createElement(AccessibleIcon, {
    label: label
  }, icon), children);
});

/**
 * @tutorial https://flora.gb.tech/docs/components/core/tabs
 */
export var TabList = forwardRef((props, forwardedRef) => {
  return /*#__PURE__*/React.createElement(StyledList, _extends({}, props, {
    "data-flora": "tab-list",
    ref: forwardedRef
  }));
});

/**
 * @component
 * @name Tabs
 * @description Tabs component
 * @tutorial https://flora.gb.tech/docs/components/core/tabs
 */
export var Tabs = forwardRef((props, forwardedRef) => {
  return /*#__PURE__*/React.createElement(StyledTabs, _extends({}, props, {
    "data-flora": "tab-container",
    ref: forwardedRef
  }));
});

/**
 * @tutorial https://flora.gb.tech/docs/components/core/tabs
 */
export var TabPanel = forwardRef((props, forwardedRef) => {
  return /*#__PURE__*/React.createElement(StyledPanel, _extends({}, props, {
    "data-flora": "tab-panel",
    ref: forwardedRef
  }));
});
//# sourceMappingURL=Tabs.js.map